// Renders the "Who's booking?" sheet, and keeps identity stamped onto holds.
//
// The sheet no longer decides WHEN to appear — the shell does, via
// askIdentityThen, so that adding an item shows the sheet FIRST and opens the
// cart drawer only once the guest is through it. Two overlays on screen at
// once (a centred sheet behind a full-height drawer) read as a broken page,
// and the drawer won: the sheet sat dimmed underneath it.
//
// What stays here is the part that has to watch the cart: re-stamping identity
// onto holds as they are added. Combo holds in particular are created by an
// RPC that takes no guest params at all, so the sweep is the only thing that
// gives them a contact.

import { useEffect, useRef } from "react";
import { useCart } from "../state/cart";
import { hasContact, useGuest } from "../state/guest";
import { getCartToken, setCartGuestContact } from "../state/booking";
import { GuestIdentitySheet } from "./GuestIdentitySheet";
import { WidgetLayer } from "./WidgetLayer";

export function GuestIdentityGate() {
  const { items } = useCart();
  const { profile, sheetOpen, closeSheet, resetIdentityAsk } = useGuest();
  const lastStamped = useRef("");

  const count = items.length;
  const identified = hasContact(profile);

  useEffect(() => {
    if (count === 0) {
      resetIdentityAsk();
      lastStamped.current = "";
      return;
    }
    if (!identified) return;
    // Only re-stamp when something actually changed — this effect runs on
    // every cart mutation and every keystroke that reaches the profile.
    const key = `${count}|${profile.firstName}|${profile.lastName}|${profile.email}|${profile.phone}`;
    if (key === lastStamped.current) return;
    lastStamped.current = key;
    void setCartGuestContact({
      cartToken: getCartToken(),
      name: `${profile.firstName} ${profile.lastName}`.trim() || null,
      email: profile.email.trim() || null,
      phone: profile.phone.trim() || null,
    });
  }, [count, identified, profile, resetIdentityAsk]);

  if (!sheetOpen) return null;
  return (
    <WidgetLayer>
      <GuestIdentitySheet onClose={closeSheet} />
    </WidgetLayer>
  );
}
